import { render, staticRenderFns } from "./ReferralBoth.vue?vue&type=template&id=07a7cf6d&"
import script from "./ReferralBoth.vue?vue&type=script&lang=ts&"
export * from "./ReferralBoth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports